import React from "react";

const SearchTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex max-w-md mx-auto bg-gray-200 rounded-full p-1 mb-4">
      <button
        onClick={() => onTabChange("full")}
        className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all duration-200 ${
          activeTab === "full"
            ? "bg-white text-[#0e4621] shadow-sm"
            : "text-gray-600 hover:text-gray-800"
        }`}
      >
        Recipe Search
      </button>
      <button
        onClick={() => onTabChange("kitchen")}
        className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition-all duration-200 ${
          activeTab === "kitchen"
            ? "bg-white text-[#0e4621] shadow-sm"
            : "text-gray-600 hover:text-gray-800"
        }`}
      >
        What's in My Kitchen
      </button>
    </div>
  );
};

export default SearchTabs;